<template>
  <section class="page-section">
    <div class="toolbar">
      <el-button class="mark-all-btn" type="primary" plain @click="markAllRead">全部标记为已读</el-button>
    </div>

    <div class="notification-list">
      <el-card v-for="item in notificationState.content" :key="item.id" class="notification-card" shadow="hover">
        <div class="notification-top">
          <div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.createTime }}</p>
          </div>
          <el-tag :type="item.isRead ? 'info' : 'danger'">{{ item.isRead == 1 ? '已读' : '未读' }}</el-tag>
        </div>
        <p class="notification-content">{{ item.content }}</p>
        <el-button v-if="item.isRead == 0" link type="primary" @click="markRead(item.id)">标记已读</el-button>
      </el-card>
    </div>

    <div v-if="notificationState.totalElements > 0" class="pager">
      <span class="pager-text">第 {{ filters.page }} / {{ totalPages }} 页</span>
      <el-button :disabled="filters.page <= 1" @click="handlePrevPage">
        <el-icon><ArrowLeft /></el-icon>
        上一页
      </el-button>
      <el-button type="primary" :disabled="filters.page >= totalPages" @click="handleNextPage">
        下一页
        <el-icon><ArrowRight /></el-icon>
      </el-button>
    </div>
  </section>
</template>

<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import { ArrowLeft, ArrowRight } from '@element-plus/icons-vue'
import {
  fetchUserNotificationUnreadCount,
  fetchUserNotifications,
  markAllUserNotificationsRead,
  markUserNotificationRead
} from '../../services/notificationService'

export default {
  name: 'NotificationsPanel',
  components: {
    ArrowLeft,
    ArrowRight
  },
  emits: ['unread-change'],
  data() {
    return {
      filters: {
        page: 1,
        pageSize: 5
      },
      notificationState: {
        content: [],
        totalElements: 0
      }
    }
  },
  computed: {
    totalPages() {
      const total = Number(this.notificationState.totalElements) || 0
      const pageSize = Number(this.filters.pageSize) || 10

      return Math.max(1, Math.ceil(total / pageSize))
    }
  },
  mounted() {
    this.loadNotifications()
  },
  methods: {
    isCancelAction(error) {
      return error === 'cancel' || error === 'close'
    },
    async loadNotifications() {
      const response = await fetchUserNotifications(this.filters)
      this.notificationState = response.data
      const unreadResponse = await fetchUserNotificationUnreadCount()
      this.$emit('unread-change', unreadResponse.data?.unreadCount ?? unreadResponse.data ?? 0)
    },
    handlePageChange(page) {
      this.filters.page = page
      this.loadNotifications()
    },
    handlePrevPage() {
      if (this.filters.page <= 1) {
        return
      }

      this.handlePageChange(this.filters.page - 1)
    },
    handleNextPage() {
      if (this.filters.page >= this.totalPages) {
        return
      }

      this.handlePageChange(this.filters.page + 1)
    },
    async markRead(id) {
      await markUserNotificationRead(id)
      ElMessage.success('已标记为已读')
      this.loadNotifications()
    },
    async markAllRead() {
      try {
        await ElMessageBox.confirm('确认将当前全部站内信标记为已读吗？', '操作确认', {
          type: 'warning',
          confirmButtonText: '确认标记',
          cancelButtonText: '取消'
        })
        await markAllUserNotificationsRead()
        ElMessage.success('全部站内信已标记为已读')
        this.loadNotifications()
      } catch (error) {
        if (this.isCancelAction(error)) {
          return
        }

        ElMessage.error(error.message || '操作失败')
      }
    }
  }
}
</script>

<style scoped>
.page-section {
  display: grid;
  gap: 18px;
}

.toolbar {
  display: flex;
  justify-content: flex-start;
}

.mark-all-btn {
  min-width: 148px;
  height: 40px;
  padding: 0 18px;
  border-radius: 12px;
  border-color: #cfe0ff;
  background: #eef4ff;
  color: #1d4ed8;
  font-weight: 600;
}

.mark-all-btn:hover {
  border-color: #bfd4ff;
  background: #e0ecff;
  color: #1e40af;
}

.notification-list {
  display: grid;
  gap: 16px;
}

.pager {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.pager-text {
  color: #475569;
  font-size: 14px;
  font-weight: 600;
}

.notification-card {
  border-radius: 18px;
}

.notification-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.notification-top h3 {
  margin: 0;
  color: #0f172a;
}

.notification-top p {
  margin: 10px 0 0;
  color: #64748b;
  font-size: 13px;
}

.notification-content {
  margin: 14px 0 4px;
  color: #334155;
  line-height: 1.8;
  white-space: pre-line;
  word-break: break-word;
}
</style>
